import React from 'react';
import { Button } from 'react-bootstrap';
import { FormProps } from '../../components/Form/Form';

function ButtonBar(props: FormProps) {
	const { form } = props;

	return (
		<div className='d-flex justify-content-end flex-row p-2 bd-highlight'>
			<Button variant='primary' type='submit' disabled={!form.isValid || form.isSubmitting}>
				Salva
			</Button>
		</div>
	);
}

export default ButtonBar;
